import { render, staticRenderFns } from "./DataSoftwareProductForm.vue?vue&type=template&id=46c858c8&scoped=true"
import script from "./DataSoftwareProductForm.vue?vue&type=script&lang=js"
export * from "./DataSoftwareProductForm.vue?vue&type=script&lang=js"
import style0 from "./DataSoftwareProductForm.vue?vue&type=style&index=0&id=46c858c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c858c8",
  null
  
)

export default component.exports